import { refs, domReady, booleanDataset } from '../modules/utils.js';

class OverlayAdvice extends HTMLElement {
  static get observedAttributes() {
    return ['data-display'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-display') {
      const display = newValue === '';
      booleanDataset(document.documentElement, 'unscrollable', display);
    }
  }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#listeners();

    if (window.location.hash === '#notice') {
      booleanDataset(this, 'display', true);
    }
  }

  #listeners() {
    this.refs.button?.addEventListener('click', () => {
      booleanDataset(this, 'display', false);
    });
  }
}

customElements.define('overlay-advice', OverlayAdvice);
